// extracted by mini-css-extract-plugin
export default {"iconAndLabel":"NftInfoDisclosures_iconAndLabel__KJ5AY"};